module.exports = __webpack_public_path__ + "img/interview_2x.5d9f6127.png";